import { createJSONStorage, persist } from "zustand/middleware";

import { create } from "zustand";

export const useCommunitiesStore = create(
  persist(
    (set) => ({
      communityId: "",
      communityData: null,
      parentEstateId: "",
    }),
    {
      name: "userCommunities",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export function getCommunityId() {
  return useCommunitiesStore.getState().communityId;
}

export function getCommunityData() {
  return useCommunitiesStore.getState().communityData;
}

export function getParentEstateId() {
  return useCommunitiesStore.getState().parentEstateId;
}

export function getCommunityType() {
  // Returns estate or tribe 
  try{
    const comdata = useCommunitiesStore.getState().communityData;
    const roleText = comdata.role.toLocaleUpperCase();
    return roleText.includes("ESTATE") || roleText.includes("CLUSTER") ? "estate" : "tribe"
  }catch(Error){
    return ""
  }
 
}
